import React from 'react';
import PropTypes from 'prop-types';
import SMFormTextField from 'components/dashboard/form/SMFormTextField';

class SMReservationEditViewEmail extends React.Component {

  textFieldDidEndEditing(e) {
    this.props.delegate.changeEmail(e.currentTarget.name, e.currentTarget.value);
  }

  render() {
    const reservation = this.props.reservation;

    return (
      <td>
        <SMFormTextField
          name="reserved_user[email]"
          value={reservation.user ? reservation.user.email : ''}
          options={{className: 'w400'}} placeholderText="example@spacemarket.co.jp"
          delegate={this} /></td>

    );
  }
}

SMReservationEditViewEmail.propTypes = {
  reservation: PropTypes.object.isRequired,
  delegate: PropTypes.object
};
export default SMReservationEditViewEmail;



// WEBPACK FOOTER //
// ./app/javascript/components/dashboard/shared/SMReservationEditViewEmail.jsx